<template>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs narrow" role="tablist" id="business-tab">
          <li
            class="nav-item"
            v-for="(item, i) in tree"
            :class="{
              'dropdown': !item.child===false && item.child.length,
              'active' : currentTab==item.key || (currentTab.indexOf(item.key)===0)
            }"
            :id="`tree-item-${i}`"
            :key="`tree-item-${i}`"
          >
            <a v-if="!item.child===false && item.child.length"
              data-toggle="dropdown"
              class="nav-link dropdown-toggle"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >{{item.name}}</a>
            <router-link :to="`/manager/condition/tab/${item.id}`" v-else
              class="nav-link"
              role="button"
              :data-item="item.key"
              :data-parent="item.key"
            >{{item.name}}</router-link>

            <ul v-if="!item.child===false && item.child.length" class="dropdown-menu" :aria-labelledby="`tree-item-${i}`">
              <li
                class="dropdown-item"
                v-for="(val, j) in item.child"
                :key="`tree-${i}-${j}`"
              >
                <router-link :to="`/tab/${val.id}`"
                role="tab"
                data-toggle="tab"
                :data-item="val.key"
                :data-parent="item.key">
                  {{val.name}}
                  <i class="text-green float-right">❯</i>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
    name: 'TabConditionHeader',
    data () {
        return {
            currentTab: 'key-1',
            tree: [
                {
                    id: '1',
                    key: 'key-1',
                    name: '使用狀況查詢'
                },
                {
                    id: '2',
                    key: 'key-2',
                    name: '編輯發佈條件'
                },    
            ],
        }
    },
   
    beforeMount () {
      let path = this.$route.path.split(/\//g)
      path.reverse()
      this.currentTab = `key-${path[0]}`
    },
}
</script>

<style>

</style>
